import axios from '../config/axios';

const API_URL = '/api/admin';

export interface BlogPost {
    _id?: string;
    title: string;
    excerpt: string;
    contentHTML: string;
    contentJSON: any;
    category: string;
    author: string;
    authorRole: string;
    status: 'draft' | 'published' | 'scheduled';
    publishDate?: string;
    featuredImage?: string;
    metaTitle?: string;
    metaDescription?: string;
    tags?: string[];
    slug?: string;
    createdAt?: string;
    updatedAt?: string;
}

export const getAllPublishedBlogPosts = async (filter?: { [key: string]: any }) => {
    const response = await axios.get(`/api/blog/`, {
        params: filter
    });
    return {
        data: response.data.data,
        pagination: response.data.pagination
    };
};

export const getAllBlogPosts = async (filter: { [key: string]: any }) => {
    const response = await axios.get(`${API_URL}/AllBlog`, {
        params: filter
    });
    return {
        data: Array.isArray(response.data) ? response.data : response.data.data,
        pagination: response.data.pagination
    };
};

export const createBlogPost = async (data: BlogPost) => {
    const response = await axios.post(`${API_URL}/blog`, data);
    return response.data;
};

export const updateBlogPost = async (slug: string, data: Partial<BlogPost>) => {
    const response = await axios.put(`${API_URL}/blog/${slug}`, data);
    return response.data;
};

export const updateBlogStatus = async (slug: string, status: 'draft' | 'published' | 'scheduled') => {
    const response = await axios.put(`${API_URL}/blog/${slug}/status`, { status });
    return response.data;
};

export const getBlogBySlug = async (slug: string) => {
    const response = await axios.get(`/api/blog/${slug}`);
    return response.data;
};

export const deleteBlogPost = async (slug: string) => {
    const response = await axios.delete(`${API_URL}/blog/${slug}`);
    return response.data;
};